import { createFileRoute } from '@tanstack/react-router'
import { MemoryManager } from '../../../../components/MemoryManager'

export const Route = createFileRoute('/platform/desa/$desaId/memory')({
  component: () => {
    const { desaId } = Route.useParams()
    return <MemoryManager desaId={desaId} />
  },
})
